import React, { useEffect, useState } from 'react'

export default function CasinoAlert() {
  const [ticker, setTicker] = useState({});

  useEffect(() => {
    fetch('https://fathomless-inlet-92831.herokuapp.com/https://cms.jamulcasinosd.com/wp-content/uploads/web-ticker/ticker.json')
      .then(response => response.json())
      .then(ticker => {
        setTicker(ticker);
      });
  }, []);

  const duration = ticker.length * 12
  const delay = duration / 2;

  return (
    <>
      <div className={`bg-wire text-white py-3 text-lg`}>
        <div className="relative flex overflow-x-scroll w-screen motion-safe:overflow-x-hidden">
          {ticker?.length ?
            <>
              <ul className="whitespace-nowrap flex motion-safe:animate-marquee-a"
                style={{ animationDuration: `${duration.toString()}s`, animationDelay: `-${delay.toString()}s` }}
              >
                {ticker?.map((winner) => {
                  return ContentItem(winner)
                })}
              </ul>

              <ul className="whitespace-nowrap hidden motion-safe:flex absolute top-0 translate-x-full motion-safe:animate-marquee-a"
                style={{ animationDuration: `${duration.toString()}s` }}
                aria-hidden={true}
              >
                {ticker?.map((winner) => {
                  return ContentItem(winner)
                })}
              </ul>
            </>
            : null}
          &nbsp;
        </div>
      </div>
    </>
  )
}
function ContentItem(winner) {
  const { date, amount, game, name } = winner
  return <li className="" key={winner}>{name} <span className="opacity-50">•</span> {amount} <span className="opacity-50">•</span> {game} <span className="opacity-50">•</span> {date}<span className="px-6 opacity-50">|</span></li>
}

